/*----------------------------------
- MARKETING PAGES: SHARED COPY (SSOT)
----------------------------------*/

/**
 * The words the product feature pages and the solutions pages share, in the shipped wording: the FAQ head's contact
 * call to action and the Ask AI row (`HomeAskAiSection`'s labels, kept so the accessible names do not change when a
 * page moves onto `WebsiteAskAi`).
 *
 * @docs docs/features/website-product-feature-pages
 */

/*----------------------------------
- CATALOG (SSOT)
----------------------------------*/

/** The FAQ head's call to action (`FAQ.tsx`'s defaults). */
export const MARKETING_FAQ_CONTACT = {
    label: 'Contact me',
    href: '/team',
} as const;

export const MARKETING_ASK_AI_COPY = {
    title: 'Ask AI about Unique Domains',
    providerTitle: (provider: string) => `Ask ${provider} about Unique Domains`,
} as const;
